import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=78d40638&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=78d40638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d40638",
  null
  
)

export default component.exports